'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowLeftOutline = function TiArrowLeftOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.2 35c-1.3 0-2.6-0.5-3.5-1.5l-11.9-11.8 11.9-11.9c1.9-1.9 5.2-1.9 7 0 1 0.9 1.5 2.2 1.5 3.5 0 1.3-0.4 2.5-1.3 3.4h8.1c2.8 0 5 2.2 5 5s-2.2 5-5 5h-8.1c0.9 0.9 1.3 2.1 1.3 3.3 0 1.3-0.5 2.6-1.5 3.5-0.9 1-2.2 1.5-3.5 1.5z m-10.7-13.3l9.5 9.5c0.7 0.6 1.8 0.6 2.4 0 0.3-0.3 0.5-0.8 0.5-1.2s-0.2-0.9-0.5-1.2l-5.5-5.5h16.1c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7h-16.1l5.5-5.5c0.3-0.3 0.5-0.7 0.5-1.2s-0.2-0.8-0.5-1.1c-0.6-0.7-1.7-0.7-2.4 0l-9.5 9.5z' })
        )
    );
};

exports.default = TiArrowLeftOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-left-outline.js
// module id = 1781
// module chunks = 0